import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAuth } from '../../../../containers/UseAuth';
import LinkButton from '../../../Buttons/LinkButton';
import { CSVLink } from 'react-csv';
import Icon from '../../../Icon/Icon';
import { cpmFromPrice, formatNumber } from '../../../../utils/functions';

const DownloadScreensToCSV = ({
    userMargin,
    customScreens = null,
    customHeaders = null,
    customName = null,
    screensState,
}) => {
    const { t } = useTranslation();
    const auth = useAuth();
    const newCampaign = useSelector((state) => state.newCampaign);
    const selectedCurrencyShortName = newCampaign?.selectedCurrency?.short_name;
    const campaignId = newCampaign.id;
    const brand = newCampaign.brand;
    const campaignName = newCampaign.name;
    const selectedScreens = screensState?.selectedScreens || [];
    const user = auth.session.user;
    const nameCSV =
        customName ||
        `Screens_${user.id}_${user.username}_${brand}_${campaignName}_${campaignId}`.replace(
            / /g,
            ''
        );

    const headers = [
        { label: 'Id', key: 'id' },
        {
            label: t(
                'sections.campaigns.new-campaign.wizard-screens.screens.table-screenName'
            ),
            key: 'alias',
        },
        {
            label: t(
                'sections.campaigns.new-campaign.wizard-screens.screens.table-screenPublisher'
            ),
            key: 'publisher.name',
        },
        {
            label: t(
                'sections.campaigns.new-campaign.wizard-screens.screens.table-screenSize'
            ),
            key: 'size',
        },
        {
            label: t(
                'sections.campaigns.new-campaign.wizard-screens.screens.table-screenStatus'
            ),
            key: 'status',
        },
        {
            label: t(
                'sections.campaigns.new-campaign.wizard-screens.screens.table-screenCPM'
            ),
            key: 'ecpm',
        },
        {
            label: t(
                'sections.campaigns.new-campaign.wizard-review.blocks.screens.screen-details.lat'
            ),
            key: 'lat',
        },
        {
            label: t(
                'sections.campaigns.new-campaign.wizard-review.blocks.screens.screen-details.lon'
            ),
            key: 'lng',
        },
        {
            label: t(
                'sections.campaigns.new-campaign.wizard-review.blocks.screens.screen-details.hasAudience'
            ),
            key: 'hasAudience',
        },
    ];

    const formatedCsv = customScreens?.length
        ? customScreens
        : selectedScreens.map((screen) => {
              const publisher =
                  screen.publisher && typeof screen.publisher === 'object'
                      ? screen.publisher
                      : { name: screen.publisher || '-' };

              return {
                  ...screen,
                  alias: screen.alias || screen.name || screen.external_id,
                  publisher,
                  lat: screen.lat ?? screen.geo?.lat,
                  lng: screen.lng ?? screen.geo?.lon,
                  ecpm: formatNumber(
                      screen.ecpm
                          ? screen.ecpm
                          : cpmFromPrice(screen.deals, userMargin),
                      'properCurrency',
                      null,
                      {
                          currency: selectedCurrencyShortName,
                      }
                  ),
              };
          });

    return (
        <CSVLink
            data={formatedCsv}
            headers={customHeaders || headers}
            filename={`${nameCSV}.csv`}>
            <Icon
                name="file-excel"
                size="lg"
                className="text-green-500 cursor-pointer mr-2"
            />
            <LinkButton>
                {t(
                    'sections.campaigns.new-campaign.wizard-review.blocks.screens.download-screen-list'
                )}
            </LinkButton>
        </CSVLink>
    );
};

export default DownloadScreensToCSV;
